import axios from 'axios';
import { API_URL } from 'configs';


export const EMP_CAMPAIGNS_SUCCESS = 'EMP_CAMPAIGNS_SUCCESS';
export const EMP_DEPARTMENTS_SUCCESS = 'EMP_DEPARTMENTS_SUCCESS';
export const EMP_DESIGNATIONS_SUCCESS = 'EMP_DESIGNATIONS_SUCCESS';
export const EMP_EMPLOYEES_SUCCESS = 'EMP_EMPLOYEES_SUCCESS';
export const EMP_APPRAISAL_STATUSES_SUCCESS = 'EMP_APPRAISAL_STATUSES_SUCCESS';
export const EMP_OFFICES_REQUEST = 'EMP_OFFICES_REQUEST';
export const EMP_OFFICES_SUCCESS = 'EMP_OFFICES_SUCCESS';
export const EMP_OFFICES_FAILURE = 'EMP_OFFICES_FAILURE';
export const EMP_CAMPAIGNS_REQUEST = 'EMP_CAMPAIGNS_REQUEST';
export const EMP_DEPARTMENTS_REQUEST = 'EMP_DEPARTMENTS_REQUEST';
export const EMP_DESIGNATIONS_REQUEST = 'EMP_DESIGNATIONS_REQUEST';
export const EMP_APPRAISAL_STATUSES_REQUEST = 'EMP_APPRAISAL_STATUSES_REQUEST';
export const EMP_CAMPAIGNS_FAILURE = 'EMP_CAMPAIGNS_FAILURE';
export const EMP_DEPARTMENTS_FAILURE = 'EMP_DEPARTMENTS_FAILURE';
export const EMP_DESIGNATIONS_FAILURE = 'EMP_DESIGNATIONS_FAILURE';
export const EMP_APPRAISAL_STATUSES_FAILURE = 'EMP_APPRAISAL_STATUSES_FAILURE';

const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER'; 
const SHOW_SNACKBAR = 'SHOW_SNACKBAR';

const showCommonLoader = (label = '') => ({
	type: SHOW_LOADER,
	common_loder_label: label
});

const hideCommonLoader = () => ({
	type: HIDE_LOADER
});


const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const showGeneralError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})

export const fetchEmployeeCampaigns = () => {
  const token = localStorage.getItem("token");

  return dispatch => {
    dispatch({ type: EMP_CAMPAIGNS_REQUEST });
    dispatch(showCommonLoader());
    
    return axios(`${API_URL}employees/campaigns`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
    .then(response => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_CAMPAIGNS_SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_CAMPAIGNS_FAILURE });
      handleErrorResponse(error, dispatch);
    });
  };
};

export const fetchEmployeeDepartments = () => {
  const token = localStorage.getItem("token");

  return dispatch => {
    dispatch({ type: EMP_DEPARTMENTS_REQUEST });
    dispatch(showCommonLoader());

    return axios(`${API_URL}employees/departments`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
    .then(response => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_DEPARTMENTS_SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_DEPARTMENTS_FAILURE });
      handleErrorResponse(error, dispatch);
    });
  };
};

export const fetchEmployeeDesignations = () => {
  const token = localStorage.getItem("token");

  return dispatch => {
    dispatch({ type: EMP_DESIGNATIONS_REQUEST });
    dispatch(showCommonLoader());

    return axios(`${API_URL}employees/designations`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
    .then(response => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_DESIGNATIONS_SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_DESIGNATIONS_FAILURE });
      handleErrorResponse(error, dispatch);
    });
  };
};

export const fetchEmployeeOffices = () => {
  const token = localStorage.getItem("token");

  return (dispatch) => {
    dispatch({ type: EMP_OFFICES_REQUEST });

    return axios(`${API_URL}employees/offices`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        const raw = response.data;
        const list = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.data)
            ? raw.data
            : [];
        dispatch({ type: EMP_OFFICES_SUCCESS, payload: list });
      })
      .catch((error) => {
        dispatch({ type: EMP_OFFICES_FAILURE });
        handleErrorResponse(error, dispatch);
      });
  };
};

export const fetchAllEmployees = () => {
  const token = localStorage.getItem("token");

  return dispatch => {
    dispatch(showCommonLoader());

    return axios(`${API_URL}employees/getAll`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
    .then(response => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_EMPLOYEES_SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch(hideCommonLoader());
      handleErrorResponse(error, dispatch);
    });
  };
};

export const fetchAppraisalStatuses = () => {
  const token = localStorage.getItem("token");

  return (dispatch, getState) => {
    const state = getState();
    const objectViewedId = state?.session?.current_object_viewed_id || '';

    dispatch({ type: EMP_APPRAISAL_STATUSES_REQUEST });
    dispatch(showCommonLoader());

    return axios(`${API_URL}appraisal-statuses`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      params: {
        object_viewed_id: objectViewedId
      },
    })
    .then(response => {
      dispatch(hideCommonLoader());
      const statuses = Array.isArray(response?.data?.statuses)
        ? response.data.statuses
        : Array.isArray(response?.data)
          ? response.data
          : (Array.isArray(response?.data?.data) ? response.data.data : []);
      dispatch({ type: EMP_APPRAISAL_STATUSES_SUCCESS, payload: statuses });
    })
    .catch(error => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_APPRAISAL_STATUSES_FAILURE });
      handleErrorResponse(error, dispatch);
    });
  };
};

 
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      /*let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      //dispatch(clockinFailure(err)*/
    }
  }
  catch (e) {
    //dispatch(clockinFailure('Unable to perform action.Something went wrong'))
  }
}  